import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const LightBulbIcon = ({ fill='#000', ...props }) => {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
        <path
            fill={fill}
            d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm3 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5z"
        />
    </Icon>
  );
};

LightBulbIcon.propTypes = {
  fill: PropTypes.string,
};

export default LightBulbIcon;
